module.exports = __webpack_public_path__ + "static/media/editor-noCirc.543ea5a9.svg";